import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { requestOTP } from '../../reducers/authReducer'

import { Form, Input, Button, notification } from 'antd'
import { MailOutlined } from '@ant-design/icons'

import { PageContainer, FormContainer, FormWrapper, FormTitle } from './style'

const RequestOTP = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const onFinish = async (values) => {
    try {
      setLoading(true)
      const res = await dispatch(requestOTP(values))

      if (res?.success) {
        notification.success({
          message: 'An OTP has been sent to your email.'
        })
        navigate('/verifyotp')
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const getInitialValues = () => {
    return (
      JSON.parse(window.localStorage.getItem('spanidea-remember-cred')) || {}
    )
  }

  return (
    <PageContainer>
      <FormContainer>
        <FormWrapper>
          <Form
            name="login"
            onFinish={onFinish}
            initialValues={getInitialValues()}
            scrollToFirstError
          >
            <FormTitle>Login</FormTitle>

            <p>
              New user? <Link to="/register">Create Account</Link>
            </p>

            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: 'Please enter your email'
                },
                {
                  pattern: /^[a-zA-Z0-9._%+-]+@spanidea\.com$/,
                  message: 'Please login with registered spanidea email'
                }
              ]}
            >
              <Input prefix={<MailOutlined />} placeholder="Enter email" />
            </Form.Item>

            <Form.Item>
              <Button block type="primary" htmlType="submit" loading={loading}>
                Get OTP
              </Button>
            </Form.Item>
          </Form>
        </FormWrapper>
      </FormContainer>
    </PageContainer>
  )
}
export default RequestOTP
